import { createSlice } from '@reduxjs/toolkit';
import { asyncRoutes, staticRoutes, whiteList } from 'app/configs/routesConfig';
import { mergeRoutes } from 'app/store/routes/utils';
import { buildAsyncRoutesFromScopes } from './asyncThunks';

const getAsyncFilteredRoutes = () => {
  const temporal = asyncRoutes.filter((route) => whiteList.includes(route.path));
  return mergeRoutes(staticRoutes, temporal);
};
// ------ Authentication --------
const userInitialState = {
  isLoading: true,
  errors: [],
  routes: getAsyncFilteredRoutes(),
};
const routesSlice = createSlice({
  name: 'routes',
  initialState: userInitialState,
  reducers: {
    setRoutes: (state, { payload }) => {
      const { asyncNewRoutes } = payload;
      return {
        ...state,
        routes: mergeRoutes(state.routes, asyncNewRoutes),
      };
    },
    resetRoutes: (state) => {
      const routes = getAsyncFilteredRoutes();
      return { routes };
    },
  },
  extraReducers: {
    [buildAsyncRoutesFromScopes.pending]: (state) => {
      return { ...state, isLoading: true };
    },
    [buildAsyncRoutesFromScopes.fulfilled]: (state, { payload }) => {
      const { selected } = payload;
      return {
        ...state,
        isLoading: false,
        errors: [],
        routes: mergeRoutes(staticRoutes, selected),
      };
    },
    [buildAsyncRoutesFromScopes.rejected]: (state, { payload }) => {
      return { ...state, isLoading: false, errors: payload };
    },
  },
});

export default routesSlice.reducer;
export const { setRoutes, resetRoutes } = routesSlice.actions;
